import { takeLatest, put, all, call } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";
import {
  ComonExportPage,
  fetchPerformanceReport,
} from "./performanceReport.services";
import {
  performanceReportFetchSuccess,
  performanceReportFetchFailure,
  performanceReportFetchResponseChanged,
  performanceReportExportAllFailure,
  performanceReportExportAllSuccess,
  performanceReportExportAllChanged,
} from "./performanceReport.action";
import PerforamanceReportTypes from "./performanceReport.types";

/** *********************** SATRT PERFORMANCE REPORT LIST ************************ */
export function* PerformanceReportListFetch({ payload }: any) {
  const key: any = "PerformanceReportKey";
  const {
    leadSourceID,
    FromDate,
    ToDate,
    CompanyID,
    InstanceName,
    branchID,
    UserID,
    UserLevel,
  } = payload;
  try {
    const jsonData: any = {
      LeadSourceID: leadSourceID,
      FromDate: FromDate,
      ToDate: ToDate,
      CompanyID: CompanyID,
      InstanceName: InstanceName,
      branchID: branchID,
      // Role scope: backend restricts Level0 to own row, TL to self+reports,
      // admins see all. Empty/absent keeps the legacy company-wide behaviour.
      UserID: UserID ?? "",
      UserLevel: UserLevel ?? "",
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(fetchPerformanceReport, fetchData);
    const body = responseData?.data ?? responseData;
    const statusCode = body?.statusCode ?? body?.StatusCode;
    if (statusCode === "100") {
      yield put(performanceReportFetchFailure(body));
    } else {
      yield put(performanceReportFetchSuccess(body));
    }
  } catch (error) {
    yield put(performanceReportFetchFailure(error));
  }
}
export function* performanceReportFetchReset() {
  yield put(performanceReportFetchResponseChanged());
}
export function* onFetchListPerformanceReport() {
  yield takeLatest(
    PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_START,
    PerformanceReportListFetch,
  );
}
export function* onPerformanceReportResponseReset() {
  yield takeLatest(
    PerforamanceReportTypes.PERFORMANCE_REPORT_FETCH_RESET_START,
    performanceReportFetchReset,
  );
}

/** *********************** END PERFORMANCE REPORT LIST ************************ */

/** *********************** SATRT PERFORMANCE REPORTEXPORT  LIST ************************ */
export function* performanceReportListExport({ payload }: any) {
  const key: any = "CreateRequestReportKey";
  const {
    IsFresh,
    ConditionExec,
    URL,
    CreateDateTime,
    RequestReportPage,
    CompanyID,
    RequestedBy,
    FromDate,
    ToDate,
    MemberID,
    DateType,
    InstanceName,
    BranchID,
  } = payload;
  try {
    const jsonData: any = {
      BranchID: BranchID,
      IsFresh: IsFresh,
      ConditionExec: ConditionExec,
      ExistRequestID: payload.ExistRequestID,
      CreateDateTime: CreateDateTime,
      RequestReportPage: RequestReportPage,
      CompanyID: CompanyID,
      RequestedBy: RequestedBy,
      URL: URL,
      FromDate: FromDate,
      ToDate: ToDate,
      MemberID: MemberID,
      DateType: DateType,
      InstanceName: InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ComonExportPage, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(performanceReportExportAllFailure(responseData.data));
    } else {
      yield put(performanceReportExportAllSuccess(responseData.data));
    }
  } catch (error) {
    yield put(performanceReportExportAllFailure(error));
  }
}
export function* performanceReportExportAllReset() {
  yield put(performanceReportExportAllChanged());
}
export function* onExportListPerforamanceReport() {
  yield takeLatest(
    PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_START,
    performanceReportListExport,
  );
}
export function* onPerforamanceReportExportReset() {
  yield takeLatest(
    PerforamanceReportTypes.PERFORMANCE_REPORT_EXPORT_RESET_START,
    performanceReportExportAllReset,
  );
}
/************************* END PERFORMANCE REPORTEXPORT ALL  LIST ************************ */

/** *********************** END PERFORMANCE REPORT DATE WISE  ************************ */

export function* performanceReportSaga() {
  yield all([
    call(onPerformanceReportResponseReset),
    call(onFetchListPerformanceReport),
    call(onExportListPerforamanceReport),
    call(onPerforamanceReportExportReset),
  ]);
}
